import {get,post} from '../utils/request';
// 获取图片验证码
export const getAuthCode = params => get('/getAuthCode',params);
// 登录
export const login = params => post('/login',params);
// 退出登录
export const loginOut = params => post('/loginOut',params);